module.exports = __webpack_public_path__ + "img/wrz.d5dd8265.png";